<template>
    <div class="pa-5">
        <div v-for="classificator in productClassificators" v-if="classificator.assigned_tab === 'specification'">
            <div class="mb-2">
                <strong>{{ getClassificatorOrClassificatorRowTitle(classificator.title) }}</strong>
            </div>
            <div v-for="cr in classificator.rows">
                <v-row no-gutters v-if="cr.value_type === 'text' || cr.value_type === 'number'">
                    <v-col class="mt-2 row-title" cols="3">{{
                        getClassificatorOrClassificatorRowTitle(cr.title)
                    }}</v-col>
                    <v-col cols="6">
                        <classificator-input
                            :classificator_value="getClassificatorValue(cr.id, classificator.classificator_type)"
                            :classificator_row="cr"
                            :classificator_type="classificator.classificator_type"
                            @changeValue="changeClassificatorValue($event)"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters v-else-if="cr.value_type === 'boolean'">
                    <v-col class="ma-0 pr-2 row-title" cols="9">{{
                        getClassificatorOrClassificatorRowTitle(cr.title)
                    }}</v-col>
                    <v-col>
                        <classificator-checkbox-input
                            :classificator_value="getClassificatorValue(cr.id, classificator.classificator_type)"
                            :classificator_row="cr"
                            :classificator_type="classificator.classificator_type"
                            @changeValue="changeClassificatorValue($event)"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters v-else-if="cr.value_type === 'text_field'">
                    <v-col cols="9">
                        <classificator-text-area-input
                            :classificator_value="getClassificatorValue(cr.id, classificator.classificator_type)"
                            :classificator_row="cr"
                            :classificator_type="classificator.classificator_type"
                            @changeValue="changeClassificatorValue($event)"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters v-else-if="cr.value_type === 'tiptap_editor'">
                    <v-col cols="9">
                        <classificator-tiptap-editor-area
                            :classificator_value="getClassificatorValue(cr.id, classificator.classificator_type)"
                            :classificator_row="cr"
                            :classificator_type="classificator.classificator_type"
                            @changeValue="changeClassificatorValue($event)"
                        />
                    </v-col>
                </v-row>
            </div>
            <v-divider class="mb-5 mt-2"></v-divider>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import ClassificatorInput from "../../../components/classificator-input.vue";
import ClassificatorCheckboxInput from "../../../components/classificator-checkbox-input.vue";
import ClassificatorTextAreaInput from "../../../components/classificator-text-area-input.vue";
import ClassificatorTiptapEditorArea from "../../../components/classificator-tiptap-editor-area.vue";
import { userTranslationFunctions } from "../../../mixins/user-translation-functions";

export default {
    name: "specification-edit-tab",
    components: {
        ClassificatorInput,
        ClassificatorCheckboxInput,
        ClassificatorTextAreaInput,
        ClassificatorTiptapEditorArea
    },
    mixins: [userTranslationFunctions],
    data() {
        return {
            data: {}
        };
    },
    computed: {
        ...mapState("ProductStore", ["activeProduct", "productClassificators"])
    },
    methods: {
        ...mapMutations("ProductStore", ["changeClassificatorValue"]),
        getClassificatorValue(cr_id, type) {
            if (this.activeProduct.data && this.activeProduct.data[type]) {
                const classificatorItemData = this.activeProduct.data[type].find(p => p.classificator_row_id === cr_id);
                if (classificatorItemData) return classificatorItemData.value;
            }
            return null;
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
::v-deep .v-input__slot {
    min-height: 9px !important;
}
::v-deep .v-select__slot > .v-select__selections {
    padding: 0px !important;
}
::v-deep .v-input__icon {
    padding-bottom: 8px;
}
</style>
